/** Parse YYYY-MM-DD or ISO string to local calendar date (midnight). */
export function parseListingDate(raw: string | null | undefined): Date | null {
  if (raw == null) return null
  const s = String(raw).trim()
  if (!s) return null
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (m) {
    const y = Number(m[1])
    const mo = Number(m[2]) - 1
    const d = Number(m[3])
    const dt = new Date(y, mo, d)
    if (dt.getFullYear() !== y || dt.getMonth() !== mo || dt.getDate() !== d) return null
    return dt
  }
  const dt = new Date(s)
  return Number.isNaN(dt.getTime()) ? null : dt
}

function startOfDay(d: Date): Date {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate())
}

const THREE_WEEKS_DAYS = 21

/** True when availability is today or in the future and within the next 21 days (inclusive). */
export function isAvailableWithinThreeWeeks(
  availabilityRaw: string | null | undefined,
  now: Date = new Date()
): boolean {
  const availability = parseListingDate(availabilityRaw)
  if (!availability) return false
  const today = startOfDay(now)
  const end = new Date(today)
  end.setDate(end.getDate() + THREE_WEEKS_DAYS)
  const av = startOfDay(availability)
  return av.getTime() >= today.getTime() && av.getTime() <= end.getTime()
}

/**
 * Whole calendar months from `from` (exclusive of partial month rule) until contract end.
 * Returns null if contract end is missing or not after `from`.
 */
export function monthsRemainingUntilContractEnd(
  contractEndRaw: string | null | undefined,
  from: Date = new Date()
): number | null {
  const end = parseListingDate(contractEndRaw)
  if (!end) return null
  const start = startOfDay(from)
  const contract = startOfDay(end)
  if (contract.getTime() <= start.getTime()) return null
  let months =
    (contract.getFullYear() - start.getFullYear()) * 12 +
    (contract.getMonth() - start.getMonth())
  if (contract.getDate() < start.getDate()) months -= 1
  if (months < 1) return null
  return months
}
